import { getStoredPermissions } from "./permissions";
import { isDesktopApp } from "./isDesktop";

export const ORG_FEATURES_CHANGED_EVENT = "cc:organization-features-changed";

export const getOrgFeatures = () => {
  const stored = getStoredPermissions();
  const features = stored?.orgFeatures;
  const callingEnabled = features?.callingEnabled !== false;
  return {
    callingEnabled,
    webCallingEnabled: callingEnabled && features?.webCallingEnabled !== false,
    desktopCallingEnabled: callingEnabled && features?.desktopCallingEnabled !== false,
    aiCallingEnabled: features?.aiCallingEnabled !== false,
  };
};

/** Org-wide calling (campaigns, call history, recordings, telephony APIs). */
export const isCallingEnabled = () => getOrgFeatures().callingEnabled;

export const isWebCallingEnabled = () => getOrgFeatures().webCallingEnabled;

export const isDesktopCallingEnabled = () => getOrgFeatures().desktopCallingEnabled;

/** Browser phone / native SIP dialer for the current client (web vs desktop app). */
export const isBrowserPhoneChannelEnabled = () =>
  isDesktopApp() ? isDesktopCallingEnabled() : isWebCallingEnabled();

export const isAiCallingEnabled = () => getOrgFeatures().aiCallingEnabled;

export const assertCallingEnabled = () => {
  if (!isCallingEnabled()) {
    const error = new Error("Calling is disabled for this organization.");
    error.code = "CALLING_DISABLED";
    throw error;
  }
};

export const assertBrowserPhoneChannelEnabled = () => {
  assertCallingEnabled();
  if (!isBrowserPhoneChannelEnabled()) {
    const error = new Error(
      isDesktopApp()
        ? "Desktop calling is disabled for this organization."
        : "Web calling is disabled for this organization."
    );
    error.code = isDesktopApp() ? "DESKTOP_CALLING_DISABLED" : "WEB_CALLING_DISABLED";
    throw error;
  }
};
